/**
 * Константы для страницы деталей баттла
 */

export const TYPE_LABELS = {
  SINGLE: 'Индивидуальный',
  TEAM: 'Командный',
};

export const STATUS_LABELS = {
  PLANNED: 'Запланирован',
  ACTIVE: 'Активен',
  FINISHED: 'Завершён',
  CANCELLED: 'Отменён',
};

export const STATUS_COLORS = {
  PLANNED: '#17a2b8',
  ACTIVE: '#28a745',
  FINISHED: '#6c757d',
  CANCELLED: '#dc3545',
};

export const VISIBILITY_LABELS = {
  PUBLIC: 'Публичный',
  PRIVATE: 'Частный',
  INVITE_ONLY: 'По приглашению',
};

export const FORMAT_LABELS = {
  AUDIO: '🎵 Аудио',
  TEXT: '📝 Текст',
};

export const ROLE_OPTIONS = [
  { value: 'ORGANIZER', label: 'Организатор' },
  { value: 'PARTICIPANT', label: 'Участник' },
  { value: 'JUDGE', label: 'Жюри' },
];

export const STATUS_OPTIONS = [
  { value: 'PENDING', label: 'Ожидает одобрения' },
  { value: 'APPROVED', label: 'Одобрен' },
  { value: 'REJECTED', label: 'Отклонён' },
  { value: 'WITHDRAWN', label: 'Отказался' },
];

export const ROUND_TYPE_OPTIONS = [
  { value: 'QUALIFYING', label: 'Отборочный' },
  { value: 'DRAW', label: 'Жеребьёвка' },
  { value: 'PAIR', label: 'Парный' },
];

export const ROUND_STATUS_OPTIONS = [
  { value: 'PREPARATION', label: 'Подготовка' },
  { value: 'RUNNING', label: 'Идёт' },
  { value: 'ENDED', label: 'Завершён' },
];

export const ROUND_STATUS_COLORS = {
  PREPARATION: '#ffc107',
  RUNNING: '#28a745',
  ENDED: '#6c757d',
};

/**
 * Системы голосования
 */
export const VOTING_SYSTEM_OPTIONS = [
  { value: 'PLUS_MINUS_ZERO', label: '+/0/- (Плюс / Ноль / Минус)' },
  { value: 'NUMERIC_10', label: '0-10 (Числовая шкала)' },
  { value: 'CRITERIA_BASED', label: 'Критериальная система' },
];

/**
 * Пресеты критериев
 */
export const CRITERIA_PRESET_OPTIONS = [
  { value: 'SCORE_5_5_2', label: '5/5/2 (Техника 5 + Текст 5 + Впечатление 2, макс. 12)' },
  { value: 'SCORE_6_5_3', label: '6/5/3 (Техника 6 + Текст 5 + Впечатление 3, макс. 14)' },
  { value: 'SCORE_5_3_1', label: '5/3/1 (Техника 5 + Текст 3 + Впечатление 1, макс. 9)' },
  { value: 'SCORE_4_3_2', label: '4/3/2 (Техника 4 + Текст 3 + Впечатление 2, макс. 9)' },
  { value: 'SCORE_3_2_1', label: '3/2/1 (Техника 3 + Текст 2 + Впечатление 1, макс. 6)' },
];

/**
 * Типы ограничений
 */
export const LIMITATION_TYPE_OPTIONS = [
  { value: 'TRACK_DURATION', label: 'Ограничение по длительности трека' },
  { value: 'TEXT_CONTENT', label: 'Ограничение по длине текста' },
  { value: 'FILE_SIZE', label: 'Ограничение по размеру файла' },
  { value: 'FILE_FORMAT', label: 'Ограничение по формату' },
  { value: 'AGE_RESTRICTION', label: 'Возрастное ограничение' },
];

/**
 * Получить отображение статуса участника
 */
export const getParticipantStatusLabel = (status) => {
  const labels = {
    PENDING: 'Ожидает одобрения',
    APPROVED: 'Одобрен',
    REJECTED: 'Отклонён',
    WITHDRAWN: 'Отозван',
  };
  return labels[status] || status;
};

/**
 * Получить отображение роли
 */
export const getRoleLabel = (role) => {
  const labels = {
    ORGANIZER: 'Организатор',
    PARTICIPANT: 'Участник',
    JUDGE: 'Жюри',
  };
  return labels[role] || role;
};
